import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { AlSection, AlTherExRow } from 'PatientCareCenter/Note/AL';
import styles from './Common.module.css';
import { codeValidForAdmit } from '_helpers';
import { CancelButton, StatusGood } from '_components';


class AlTherEx extends React.Component {

    constructor(props) {
        super();
        this.state = {
            showWarning: false
        };
    }

    add() {
        if (this.props.trtValid || (!this.props.trtValid && this.props.therexs.length > 0)) {
            this.props.addAlRow(this.props.noteId, 'MLTHEREX', 'XLTE', 'XLTENO', 'XLTEXLNO', this.props.xlno, 'NEW_XLTENO');
            this.setState({ showWarning: false });
        } else if (!this.props.trtValid && this.props.therexs.length === 0) {
            this.setState({ showWarning: true });
        }
    }

    componentDidUpdate() {
        if (this.props.therexs.length === 0 && this.props.time !== null) {
            this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLTIMETHEREX', 'XLTIMETHEREXASSIST', 'XLTIMETHEREXTHERAPIST']);
        }
    }

    confirmPending() {
        this.props.addAlRow(this.props.noteId, 'MLTHEREX', 'XLTE', 'XLTENO', 'XLTEXLNO', this.props.xlno, 'NEW_XLTENO');
        this.setState({ showWarning: false });
    }

    remove() {
        this.setState({ showWarning: false });
    }

    render() {
        return (
            <AlSection
                id='al_therex'
                name='Therapeutic Exercise (97110)'
                timeField='XLTIMETHEREX'
                timeRequired={this.props.containsPerformed && this.props.time === null ? true : false}
                timeVisible={this.props.therexs.length > 0 ? true : false}
                trackAssist={this.props.trackAssist}
                onAdd={() => this.add()}
                className={this.props.className}
            >

                {this.state.showWarning &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.warning_msg}>This treatment code is not covered by the patient's payer and will <b>not</b> be reimbursed.  Do you wish to add it anyway?</span>
                        <span className={styles.yes_button} >
                            <StatusGood size='extra-small' title='Yes' onClick={() => this.confirmPending()} />
                        </span>
                        <span className={styles.no_button} >
                            <CancelButton size='extra-small' title='No' onClick={() => this.remove()} />
                        </span>
                    </div>
                }

                {this.props.therexs.length > 0 &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.col1_header}>To Improve</span>
                        <span className={styles.col2_header}>Activity</span>
                        <span className={styles.col3_header}>Sets/Reps/Weight/Time</span>
                        <span className={styles.col4_header}>Performed</span>
                    </div>
                }

                {Object.keys(this.props.therexs)
                    .map(key => {
                        const result = this.props.therexs[key];
                        return (
                            <AlTherExRow key={result.XLTENO} id={result.XLTENO} />
                        )
                    })
                }
            </AlSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addAlRow: bindActionCreators(noteActions.addAlRow, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let trackAssist = state.entities.admissions[epno].contractTracksAssistant;
    let isLicensed = state.entities.authentication.user.islicensed;
    let containsPerformed = state.entities.notes.MLTHEREX &&
        Object.keys(state.entities.notes.MLTHEREX)
            .filter(key => {
                return (state.entities.notes.MLTHEREX[key].XLTEXLNO === xlno && state.entities.notes.MLTHEREX[key].XLTEPERFORMED)
            }).length > 0 ? true : false;


    return {
        noteId,
        xlno,
        time: state.entities.notes.MLEXLOG[xlno].XLTIMETHEREX,
        trtValid: codeValidForAdmit(epno, '97110'),
        therexs: Object.keys(state.entities.notes.MLTHEREX)
            .filter(key => {
                return (state.entities.notes.MLTHEREX[key].XLTEXLNO === xlno)
            })
            .sort((a, b) => state.entities.notes.MLTHEREX[a].XLTENO - state.entities.notes.MLTHEREX[b].XLTENO)
            .map(key => state.entities.notes.MLTHEREX[key]),
        isLicensed,
        containsPerformed,
        trackAssist,
    };
}

const connectedAlTherEx = connect(mapStateToProps, mapDispatchToProps)(AlTherEx);
export { connectedAlTherEx as AlTherEx };

